export default function CpdBadge(props) {
  if (!props.children[0]) return null

  return (
    <div {...props} className="cpdBadge">
      <span className="cpdBadge-score">
        [{ props.children } 
      </span>
    </div>
  )
}
